import React from "react";
import { Form, Select } from "semantic-ui-react";

import DateTimePicker from "../../../components/DateTimePicker";

const EmailDeliveryTime = ({
  timeZone,
  timeZones,
  sendNow,
  emailDeliveryTime,
  setEmailDeliveryTime,
  error,
}) => (
  <Form.Group grouped style={{ alignItems: "flex-start" }}>
    <Form.Group inline style={{ margin: 0 }}>
      <Form.Field label="Email Delivery Time" required />
      <Form.Radio
        label="Send Now"
        checked={sendNow}
        onChange={() => setEmailDeliveryTime("sendNow", true)}
      />
      <Form.Radio
        label="Send Later"
        checked={!sendNow}
        onChange={() => setEmailDeliveryTime("sendNow", false)}
      />
    </Form.Group>
    {!sendNow && (
      <Form.Group inline style={{ paddingTop: "1em" }}>
        <DateTimePicker
          required={true}
          name="emailDeliveryTime"
          label="Delivery Time & Date"
          dateTime={emailDeliveryTime}
          timeZone={timeZone}
          dateFormat="YYYY-MM-DD"
          style={{ marginTop: "0.5em", marginLeft: "1em", width: "250px" }}
          setDateTime={emailDeliveryTime =>
            setEmailDeliveryTime("emailDeliveryTime", emailDeliveryTime)
          }
          error={error}
        />
        <Form.Field style={{ marginTop: "0.5em", marginLeft: "1em", flex: 1 }}>
          <label style={{ display: "block" }}>Time Zone</label>
          <Select
            search
            value={timeZone}
            options={timeZones}
            onChange={(_, { value: timeZone }) =>
              setEmailDeliveryTime("timeZone", timeZone)
            }
            placeholder="Select timezone"
          />
        </Form.Field>
      </Form.Group>
    )}
  </Form.Group>
);

export default EmailDeliveryTime;
